import { types } from 'mobx-state-tree'

const TrafficRegionConfiguration = types
  .model('TrafficRegionConfiguration', {
    showCountyDropDown: types.optional(types.boolean, true),
    showCourtDropDown: types.optional(types.boolean, true),
    allowTLC: types.optional(types.boolean, false)
  })

export default TrafficRegionConfiguration
